// Lucide icon: lock-open (https://lucide.dev/icons/lock-open)
import { LockOpen } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconUnlock = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <LockOpen />
    </IconComponentStyled>
  )
}
